// See docs: https://tanstack.com/router/latest/docs/framework/react/guide/custom-link#mui-example

import Button from '@mui/material/Button';
import { createLink } from '@tanstack/react-router';

import type { ButtonProps } from '@mui/material/Button';
import type { LinkComponent } from '@tanstack/react-router';

function MuiButton(props: Omit<ButtonProps<'a'>, 'href'>) {
	return <Button component='a' {...props} />;
}

const WrappedButton = createLink(MuiButton);

// eslint-disable-next-line react/function-component-definition -- Need to declare the type of the component as a whole
export const ButtonLink: LinkComponent<typeof MuiButton> = function (props) {
	return <WrappedButton {...props} />;
};
